import React, { type JSX } from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { useStyles } from './styles';
import { Typography, useTheme } from '@mui/material';
import { FormInputProps } from '@fiji/common/src/features/common/commonTypes';
import { CustomTransComponent } from '../CustomTransComponent';

const Input = ({ id, name, label, control, rules, fieldLimit, helperText, disabled }: FormInputProps): JSX.Element => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const withLocaleKey = (rule: any): any => {
        if (!rule) return rule;
        const { localeKey, ...rest } = rule;
        return { ...rest, message: localeKey ? `ADD_DEVICE_FORM:${localeKey}` : rest.message };
    };

    const rulesInput = (): object => ({
        ...rules,
        ...(rules?.required && { required: withLocaleKey(rules.required) }),
        ...(rules?.pattern && {
            pattern: {
                ...withLocaleKey(rules.pattern),
                value: new RegExp(rules.pattern.value, 'i'),
            },
        }),
        ...(rules?.min && { min: withLocaleKey(rules.min) }),
        ...(rules?.max && { max: withLocaleKey(rules.max) }),
    });

    return (
        <Controller
            name={name}
            control={control}
            rules={rulesInput()}
            render={({ field: { onChange, value }, fieldState: { error } }): JSX.Element => (
                <>
                    <TextField
                        id={id}
                        className={classes.formControl}
                        helperText={
                            error ? (
                                <CustomTransComponent translationKey={error.message ?? ''} />
                            ) : helperText ? (
                                <CustomTransComponent translationKey={`ADD_DEVICE_FORM:${helperText}`} />
                            ) : null
                        }
                        error={!!error}
                        onChange={onChange}
                        value={value}
                        fullWidth
                        label={label}
                        variant="filled"
                        sx={fieldLimit ? { marginBottom: '0 !important' } : {}}
                        disabled={disabled}
                        inputProps={{ ...(fieldLimit && { maxLength: fieldLimit }) }}
                    />
                    {fieldLimit ? (
                        <Typography variant="body2" className="custom-add-device-field-lengths-style">
                            {`${value ? value.length : 0}/${fieldLimit}`}
                        </Typography>
                    ) : null}
                </>
            )}
        />
    );
};

export default Input;
